<template>
    <div class="communication">
        <b-card>
            <b-row>
                <b-col>
                    <h1>Communication</h1>
                </b-col>
            </b-row>
            <b-row v-if="issueid && issueid>0 || thread && thread.id">
                <b-col cols="12">
                    <section class="chat">
                        <div class="messages-chat">
                            <div v-for="(message, idx) in chat" :key="message.id || idx">
                                <template v-if="message.dam==marsilli">
                                    <div class="message">
                                        <div class="mright">
                                            <p class="text">{{message.message}}</p>
                                        </div>
                                    </div>
                                    <p class="mright-time time">{{message.ts}} - {{message.name}} {{message.surname}}</p>
                                </template>
                                <template v-else>
                                    <div class="message">
                                        <div class="mleft">
                                            <p class="text">{{message.message}}</p>
                                        </div>
                                    </div>
                                    <p class="mleft-time time">{{message.ts}} - {{message.name}} {{message.surname}}</p>
                                </template>
                            </div>
                        </div>
                        <div class="footer-chat">
                            <div class="left"><input type="text" v-model="message" class="write-message" placeholder="Type your message here"></div>
                            <div class="right"><v-icon name="paper-plane" scale="2" class="cursor" @click="sendMessage" /></div>
                            <div class="clear"></div>
                        </div>
                    </section>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col cols="12">
                    <p v-if="threadmode">Please select a thread to view the chat</p>
                    <!-- <p v-else>Please select an action to view the chat</p> -->
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";

export default {
    data: function () {
        return {
            chat: [],
            message: "",
            socket: null,
            m: null,
        };
    },
    name: "Communication",
    props: {
        issueid: Number,
        actionid: Number,
        thread: { type: Object, default: null },
        threadmode: Boolean,
    },
    created(){
        console.log("Communication created");
        this.socket = API.getSocket();
        this.socket.on('chat', (msg) => {
            this.chat.push(msg);
            console.log("chat",msg);
            this.scrollToBottom();
        });
        this.socket.on('connect', () => { 
            console.log('Connected to Socket.IO server'); 
        }); 
        this.socket.on('disconnect', () => { 
            console.log('Disconnected from Socket.IO server'); 
        }); 
    },
    watch: {
        async actionid() {
            await this.updChat()
            this.scrollToBottom()
        },
        async thread() {
            await this.updChat()
            this.scrollToBottom()
        },
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        marsilli() {
            return this.$store.getters.marsilli
        },
    },
    async mounted() {
        this.m = this.$store.getters.machine;
        await this.updChat()
        this.scrollToBottom()
    },
    methods: {
        async updChat(){
            if(this.threadmode) 
                this.chat = await API.threadmsgs(this.section,this.thread.id) 
            else
                this.chat = await API.chat(this.section,this.m.codice,this.issueid, null) // una chat per issue
            console.log("chat:", this.chat);
        },
        async sendMessage() {
            console.log("sendMessage",this.message);
            let da = this.$store.getters.userId;
            if(this.threadmode) {
                let ret = await API.threadmsgSend(this.thread.id, da, null, this.message, this.section)
                console.log("sendMessage ret:", ret);
                this.chat.push(ret)
                this.socket.emit('chat', ret);
            } else {
                let ret = await API.chatSend(this.m.codice, this.issueid, null, da, null, this.message, this.section)
                console.log("sendMessage ret:", ret);
                this.chat.push(ret)
                this.socket.emit('chat', ret);
            }
            this.message = ""
            this.scrollToBottom()
        },
        scrollToBottom() {
            this.$nextTick(() => {
                let div = document.querySelector(".messages-chat");
                if(div) {
                    div.scrollTop = div.scrollHeight - div.clientHeight;
                }
            });
        },
    },
};
</script>

<style scoped>
.clear {
    clear: both;
}
.left {
    float: left;
    width: 80%;
}
.right {
    float: right;
}
.left input {
    width: 100%;
}
.cursor {
    cursor: pointer;
}
.chat {
  width: 100%;
  height: calc(100vh - 700px);
}

.chat .message p {
    margin-bottom: 2px;
}

.header-chat {
  background-color: #FFF;
  height: 90px;
  box-shadow: 0px 3px 2px rgba(0,0,0,0.100);
  display:flex;
  align-items: center;
}

.chat .header-chat .icon {
  margin-left: 30px;
  color:#515151;
  font-size: 14pt;
}

.chat .header-chat .name {
  margin: 0 0 0 20px;
  text-transform: uppercase;
  font-family:'Montserrat', sans-serif;
  font-size: 13pt;
  color:#515151;
}

.chat .header-chat .right {
  position: absolute;
  right: 40px;
}

.chat .messages-chat {
  padding: 25px 35px;
  height: calc(100vh - 800px);
  overflow: auto;
}

.chat .messages-chat .message {
  display:flex;
  align-items: center;
  margin-bottom: 1px;
}

.chat .messages-chat .message .photo {
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.chat .messages-chat .text {
  background-color: #f6f6f6;
  /* padding: 15px; */
  border-radius: 12px;
}

.time {
  font-size: 10px;
  color:lightgrey;
  margin-bottom:8px;
  text-align: left;
}

.mright-time {
    text-align: right;
}

.mright {
  float: right;
  width: 75%;
  margin-right: 0px !important;
  margin-left:auto; /* flexbox alignment rule */
}
.mleft {
  float: left;
  width: 75%;
  margin-left: 0px !important;
  margin-right:auto; /* flexbox alignment rule */
}

.mright .text {
  background-color: #e3effd !important;
}

.footer-chat {
  width: 100%;
  height: 80px;
  display:flex;
  align-items: center;
  position:absolute;
  bottom: 0;
  background-color: transparent;
  border-top: 2px solid #EEE;
  
}

.chat .footer-chat .icon {
  margin-left: 30px;
  color:#C0C0C0;
  font-size: 14pt;
}

.chat .footer-chat .send {
  color:#fff;
  background-color: #4f6ebd;
  position: absolute;
  right: 50px;
  padding: 12px 12px 12px 12px;
  border-radius: 50px;
  font-size: 14pt;
}

.chat .footer-chat .name {
  margin: 0 0 0 20px;
  text-transform: uppercase;
  font-family:'Montserrat', sans-serif;
  font-size: 13pt;
  color:#515151;
}

.chat .footer-chat .right {
  position: absolute;
  right: 40px;
}

.write-message {
  border:none !important;
  width:60%;
  height: 50px;
  margin-left: 20px;
  padding: 10px;
}

.footer-chat svg {
  fill: #9A240D;
}
.footer-chat *::-webkit-input-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
}
.footer-chat input *:-moz-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
}
.footer-chat input *::-moz-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
  margin-left:5px;
}
.footer-chat input *:-ms-input-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
}
</style>
